export const KEYWORD_QUERYSTRING_NAME = 'q';
export const SEARCH_HITS_PER_PAGE = 10;
export const CHAR_LIMIT_FOR_SUGGESTIONS = 3;
export const CHAR_MINIMAL_FOR_SEARCH = 1;
export const SEARCH_DEBOUNCE_TIME = 125;
export const MOST_SEARCHED_FOR_HITS = 5;
export const SEARCH_RESULTS_URL = '/zoekresultaten';
export const SEARCH_ANONYMOUS_USER_TOKEN = 'anonymous_user';
